import cookie from 'js-cookie'
import type { NavigationGuard } from 'vue-router'

import { config } from '@/lib/helpers/config.helpers'
import { useAuthStore } from '@/stores/auth.stores'

export const loginRedirect: NavigationGuard = async (to) => {
  const authStore = useAuthStore()
  const isAuthenticated = await authStore.authenticate()

  if (isAuthenticated) {
    const storeId = to.query.store_id as string | undefined
    if (storeId) {
      cookie.set('advertiserId', storeId)
    }

    const redirect = to.query.redirect as string | undefined
    if (redirect) {
      return { path: redirect }
    }

    return { name: 'overview' }
  }

  const pathname = to.path === '/reset-password' ? '/auth/recovery' : '/auth/login'
  const identityAppLogin = new URL(pathname, config.identityAppUrl)
  identityAppLogin.searchParams.append('app', 'advertiser')

  const returnUrl = new URL(to.fullPath, window.location.origin)
  identityAppLogin.searchParams.append('returnUrl', returnUrl.toString())

  window.location.replace(identityAppLogin.toString())
  return false
}
